import request from "@/utils/request"
//获取累计收益额数据
export function getSpotAarnings(params) {
    return request({
        method: 'get',
        url: 'actual/spot/earnings/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}
//每日盈亏
export function getSpotDayinfo(params) {
    return request({
        method: 'get',
        url: 'actual/spot/dayinfo/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}
//资产分布于现货盈亏基础数据
export function getSpotBaseinfo(params) {
    return request({
        method: 'get',
        url: 'actual/spot/baseinfo/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}
//总资产估值
export function getSpotAssets(params) {
    return request({
        method: 'get',
        url: 'actual/spot/assets/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}
//累计收益率
export function getSpotScale(params) {
    return request({
        method: 'get',
        url: 'actual/spot/scale/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}

//历史记录
export function getSpotHistory(params) {
    return request({
        method: 'get',
        url: 'actual/spot/history/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}


// WEBPACK FOOTER //
// ./src/api/spot.js